/**
 * Visitor personalization — infer a lightweight "who is this reader" signal from
 * first-touch referrer and on-page dwell, then adapt content ordering. Everything is
 * local to the browser; nothing about a visit is ever sent to a server.
 */

export type Persona =
  | "writer"
  | "publishing"
  | "creator"
  | "developer"
  | "standards";

export const PERSONAS: Persona[] = [
  "writer",
  "publishing",
  "creator",
  "developer",
  "standards",
];

/** Confidence scores per persona. Not a single label — a blend, so a developer who
 * lingers on provenance reads as developer+standards. */
export type PersonaVector = Record<Persona, number>;

export type ResolvedPersona = Persona | "unknown";

export function emptyVector(): PersonaVector {
  return { writer: 0, publishing: 0, creator: 0, developer: 0, standards: 0 };
}
